import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnderline = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "1em",
	viewBox: "-4 -4 32 32",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m4.5 19.5h15m-2.5-14.5v7.6c0 2.42-2.25 4.4-5 4.4s-5-1.98-5-4.4v-7.6m8 0h4m-14 0h4",
		fill: "none",
		stroke: "currentColor"
	})
});
export default SvgUnderline;
